/*
 * @Author: 朱占为
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-07-20 10:37:46
 * @LastEditTime: 2021-11-05 11:08:53
 */

import { post } from '../utils/request.js';
import $api from "src/config/api.config"  
export const postTest = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};
export const getReview = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};
export const getRecommendedReviews = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};
export const getRankHistory = async(params = null) => {
  try {
    const res = await post($api.GET_RANK_HISTORY, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};
export const getKeywordHistory = async(params = null) => {
  try {
    const res = await post($api.GET_KEYWORD_HISTORY, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};
//获取app的rating信息
export const getAppRatings = async(params = null) => {
  try {
    const res = await post($api.GET_RATING_INFO, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};
//获取app的rating信息
export const getAppRanking = async(params = null) => {
  try {
    const res = await post($api.GET_RANKING_INFO, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};

//获取app的rating信息
export const getKeywordList = async(params = null) => {
  try {
    const res = await post($api.GET_KEYWORD_INFO, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};
//获取ReadPushMsg
export const getReadPushMsg = async(params = null) => {
  try {
    const res = await post($api.GET_READ_PUSH_MSG, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};

//获取app的rating信息
export const getReviewList = async(params = null) => {
  try {
    const res = await post($api.GET_REVIEW_INFO, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};
//获取PushMsg
export const getPushMsg = async(params) => {
  try {
    const res = await post($api.GET_PUSH_MSG, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};

//获取app的rating信息
export const getValidateInfo = async(params = null) => {
  try {
    const res = await post($api.GET_VALIDATE_INFO, params);
    return res.data;
  } catch (error) {
    return Promise.resolve(null);
  }
};
